import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';
import AccessGate from './components/AccessGate';
import NavBar from './components/NavBar';
import { ToastProvider } from './components/Toast';
import { ConfirmProvider } from './components/ConfirmDialog';
import { ThemeProvider } from './context/ThemeContext';
import { ProjectProvider } from './context/ProjectContext';
import Dashboard from './pages/Dashboard';
import MySubmissionsPage from './pages/MySubmissionsPage';
import AssignedForReviewPage from './pages/AssignedForReviewPage';
import AllSessionsPage from './pages/AllSessionsPage';
import ReviewPage from './pages/ReviewPage';
import SettingsLayout from './pages/settings/SettingsLayout';
import SettingsHub from './pages/settings/SettingsHub';
import PushTargetSettingsPage from './pages/settings/PushTargetSettingsPage';
import LlmSettingsPage from './pages/settings/LlmSettingsPage';
import GitSettingsPage from './pages/settings/GitSettingsPage';
import UserManagementPage from './pages/settings/UserManagementPage';
import MySettingsHub from './pages/settings/MySettingsHub';
import MyLlmSettingsPage from './pages/settings/MyLlmSettingsPage';
import MyGitSettingsPage from './pages/settings/MyGitSettingsPage';
import MyTestLinkSettingsPage from './pages/settings/MyTestLinkSettingsPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import GeneratorPage from './pages/GeneratorPage';
import ApiTestingPage from './pages/ApiTestingPage';
import WebAutomationPage from './pages/WebAutomationPage';
import McpCodegenPage from './pages/McpCodegenPage';

// Keeps GeneratorPage and ApiTestingPage mounted at all times so that
// uploaded files and form state survive navigation to other pages.
function KeepAlivePages() {
  const { pathname } = useLocation();
  return (
    <>
      <div style={{ display: pathname === '/generator'   ? 'block' : 'none' }}><GeneratorPage /></div>
      <div style={{ display: pathname === '/api-testing' ? 'block' : 'none' }}><ApiTestingPage /></div>
    </>
  );
}

export default function App() {
  return (
    <ThemeProvider>
    <ProtectedRoute>
      <AccessGate>
      <ToastProvider>
      <ConfirmProvider>
      <ProjectProvider>
      <div className="app-layout">
        <NavBar />
        <main className="app-main">
        <div className="app-main-inner">
          <KeepAlivePages />
          <Routes>
            {/* Dashboard layout with sub-nav */}
            <Route path="/" element={<Dashboard />}>
              <Route index element={<Navigate to="my-submissions" replace />} />
              <Route path="my-submissions" element={<MySubmissionsPage />} />
              <Route path="assigned"       element={<AssignedForReviewPage />} />
              <Route path="all-sessions"   element={<AllSessionsPage />} />
            </Route>

            {/* Placeholder routes so the * redirect doesn't fire on these paths */}
            <Route path="/generator"   element={null} />
            <Route path="/api-testing" element={null} />

            <Route path="/sessions/:sessionId" element={<ReviewPage />} />
            <Route path="/web-automation"      element={<WebAutomationPage />} />
            <Route path="/web-automation/mcp/:jobId" element={<McpCodegenPage />} />
            <Route path="/settings" element={<SettingsLayout />}>
              <Route index               element={<SettingsHub />} />
              <Route path="push-target"  element={<PushTargetSettingsPage />} />
              <Route path="llm"          element={<LlmSettingsPage />} />
              <Route path="git"          element={<GitSettingsPage />} />
              <Route path="users"        element={<UserManagementPage />} />
              <Route path="projects"     element={<ProjectsPage />} />
              <Route path="projects/:id" element={<ProjectDetailPage />} />
              <Route path="profile"          element={<MySettingsHub />} />
              <Route path="profile/llm"      element={<MyLlmSettingsPage />} />
              <Route path="profile/git"      element={<MyGitSettingsPage />} />
              <Route path="profile/testlink" element={<MyTestLinkSettingsPage />} />
            </Route>
            <Route path="*"                    element={<Navigate to="/my-submissions" replace />} />
          </Routes>
        </div>
        </main>
      </div>
      </ProjectProvider>
      </ConfirmProvider>
      </ToastProvider>
      </AccessGate>
    </ProtectedRoute>
    </ThemeProvider>
  );
}
